var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0495 13.395C13.5285 15.855 13.311 18.75 11.542 19.92C9.773 21.06 7.134 19.995 5.6405 17.535C4.1615 15.075 4.3935 12.15 6.1625 11.01C7.9315 9.87 10.5705 10.935 12.0495 13.395ZM14.5 23.625C17.4 23.625 18.125 22.5 18.125 22.5C18.125 22.5 17.4 25.5 14.5 25.5C11.6 25.5 10.875 22.545 10.875 22.5C10.875 22.5 11.6 23.625 14.5 23.625ZM22.8375 11.01C24.6065 12.15 24.8385 15.075 23.3595 17.535C21.866 19.995 19.227 21.06 17.458 19.92C15.689 18.75 15.4715 15.855 16.9505 13.395C18.4295 10.935 21.0685 9.87 22.8375 11.01ZM14.5 27C18.125 27 26.1 19.29 26.1 13.5C26.1 7.71 20.8945 3 14.5 3C8.1055 3 2.9 7.71 2.9 13.5C2.9 19.29 10.875 27 14.5 27ZM14.5 0C22.475 0 29 6.06 29 13.5C29 19.62 20.764 30 14.5 30C8.236 30 0 19.62 0 13.5C0 6.06 6.525 0 14.5 0Z",
    fill: "#02E4C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.35f321d2c921e221c0aca2c5ee5f1a0b.svg";
export { ForwardRef as ReactComponent };